import { twMerge } from 'tailwind-merge';
import { type ClassValue, clsx } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const searchQueryByRecord = (
  queryOptions: Record<string, any> | undefined,
) =>
  new URLSearchParams(
    Object.entries(queryOptions || {}).reduce(
      (acc, [key, value]) => ({ ...acc, [key]: `${value}` }),
      {},
    ),
  );
